import { Children, useCallback, useEffect, useState } from "react";

import styled from "styled-components";

import HtmlContent from "../../components/general/misc/HtmlContent";
import MenuTitle from "../../components/general/misc/MenuTitle";

import { getAboutService } from "../../services/pagesRequestServices";
import { mergeObjectByKey } from "../../utilities/merge";

import "./About.scss";
import variables from "../../assets/js/variables";

const { colors } = variables; 

const aboutInfo = [
  {
    code: "1061",
    title: "رسالت",
  },
  {
    code: "1062",
    title: "حوزه فعالیت",
  },
  {
    code: "1063",
    title: "مزیت",
  },
];

const About = () => {
  const [aboutData, changeAboutData] = useState({});

  const getAboutData = useCallback(() => {
    return getAboutService().then((res) =>
      changeAboutData(mergeObjectByKey(res, aboutInfo, "code"))
    );
  }, []);

  useEffect(() => {
    getAboutData();
  }, [getAboutData]);

  return (
    <Styles>
      <div className="row subpage__container">
        {Children.toArray(
          (aboutData.details || []).map((item) => (
            <div className="col-12 pb-3 px-0 px-md-2">
              <div className={"border border-blue rounded py-2 px-3 h-100"}>
                <MenuTitle text={item.title} />
                <div className="text-12 line-height-2x text-white text-justify">
                  <HtmlContent rawHtml={item.content} />
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </Styles>
  );
};

export default About;

const Styles = styled.span`
  img {
    padding: 0.3rem;
    margin-left: auto;
    margin-right: auto;
    display: block;
    max-width: 100%;
    min-width: auto;
    border: solid 0.3rem ${colors.brand};
    border-radius: 1rem;
  }
`;
